module.exports = __webpack_public_path__ + "media/icons/check-off@2x-923a3a87.png";